import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { ApplicationTreatmentsState } from '../actions/applicationTreatments/types/state';
import { ApplicationTreatment } from '../types/ApplicationTreatment';

const getApplicationTreatments = (state: AppState): ApplicationTreatmentsState => state.applicationTreatment;

export const getApplicationTreatmentsLoading = createSelector(
  [getApplicationTreatments],
  (treatments) => treatments.isFetching
);

export const getApplicationTreatmentsLoaded = createSelector(
  [getApplicationTreatments],
  (treatments) => treatments.hasFetched
);

export const getApplicationTreatmentsBySeason = createSelector(
  [
    getApplicationTreatments,
    (_state: AppState, seasonCode: string) => seasonCode
  ],
  (treatments, seasonCode): ApplicationTreatment[] => {
    const seasonTreatments = treatments.bySeason[seasonCode] || [];
    return seasonTreatments;
  }
);

export const getAllApplicationTreatmentsBySeason = createSelector(
  [getApplicationTreatments],
  (treatments) => treatments.bySeason
);